import { useEffect } from 'react';

/**
 * SEO Component — Dynamically sets page title, meta description,
 * keywords, Open Graph, Twitter Card, and canonical URL.
 * No external package needed.
 */
const SEO = ({
  title,
  description,
  keywords,
  canonicalPath = '',
  ogImage = 'https://vishwadigitech.com/og-image.jpg',
  ogType = 'website',
}) => {
  const siteUrl = 'https://vishwadigitech.com';
  const fullCanonical = `${siteUrl}${canonicalPath}`;
  const fullTitle = title
    ? `${title} | Vishwa DigiTech`
    : 'Vishwa DigiTech – Digital Marketing & Web Development in Sangli';

  useEffect(() => {
    // ── Page Title ──────────────────────────────────────────
    document.title = fullTitle;

    // ── Helper to set/create meta tag ────────────────────────
    const setMeta = (attr, attrValue, content) => {
      let el = document.querySelector(`meta[${attr}="${attrValue}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, attrValue);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    // ── Standard Meta ────────────────────────────────────────
    setMeta('name', 'description', description || '');
    setMeta('name', 'keywords', keywords || '');
    setMeta('name', 'robots', 'index, follow');
    setMeta('name', 'author', 'Vishwa DigiTech');

    // ── Open Graph (Facebook / WhatsApp preview) ─────────────
    setMeta('property', 'og:title', fullTitle);
    setMeta('property', 'og:description', description || '');
    setMeta('property', 'og:type', ogType);
    setMeta('property', 'og:url', fullCanonical);
    setMeta('property', 'og:image', ogImage);
    setMeta('property', 'og:site_name', 'Vishwa DigiTech');
    setMeta('property', 'og:locale', 'en_IN');

    // ── Twitter Card ─────────────────────────────────────────
    setMeta('name', 'twitter:card', 'summary_large_image');
    setMeta('name', 'twitter:title', fullTitle);
    setMeta('name', 'twitter:description', description || '');
    setMeta('name', 'twitter:image', ogImage);

    // ── Canonical URL ────────────────────────────────────────
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', fullCanonical);

  }, [fullTitle, description, keywords, fullCanonical, ogImage, ogType]);

  return null;
};

export default SEO;
